/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DeathCause {
    AIDS_RELATED = 'aidsRelated',
    NOT_AIDS_RELATED = 'notAidsRelated',
    UNKNOWN = 'unknown',
}
